const reorder = (list, startIndex, endIndex) => {
    const [removed] = list.splice(startIndex, 1);
    list.splice(endIndex, 0, removed);
    return list;
};

const copy = (source, destination, draggableId, droppableDestination) => {
    const item = findColumnByName(source, draggableId);
    let isExists = item && destination.some(e => e.name === item.name);
    if (!isExists) {
        destination.splice(droppableDestination.index, 0, {...item});
    }
    return destination;
};

const copySort = (source, destination, droppableSource, droppableDestination) => {
    const item = source[droppableSource.index];
    let isExists = destination.some(e => e.field === item.name);
    if (!isExists) {
        destination.splice(droppableDestination.index, 0, {field: item.name, label: item.label, direction: 'ASC'});
    }
    return destination;
};

const copyValues = (source, destination, droppableSource, droppableDestination) => {
    const item = source[droppableSource.index];
    let isExists = destination.some(e => e.field === item.name);
    if (!isExists) {
        destination.splice(droppableDestination.index, 0, {
            field: item.name,
            label: `sumOf${item.label}`,
            calculationType: 'sum',
        });
    }
    return destination;
};

const copyFromColumns = (source, destination, droppableSource, droppableDestination) => {
    const item = source[droppableSource.index];
    let isExists = destination.some(e => e.field === item.name);
    if (!isExists) {
        destination.splice(droppableDestination.index, 0, item);
    }
    return destination;
};

const checkForDroppedColumns = (source = [], columns = []) => {
    let newSource = JSON.parse(JSON.stringify(source));
    findForDroppedColumn(newSource, columns);
    return newSource;
};

const orderedColumns = (arr, parentName) => {
    arr.forEach((item) => {
        item.name = parentName ? `${parentName}.${item.name}` : item.name;
        if ((item.type === ('entityEmbedded' || 'entityMixed')) && item.schema) {
            orderedColumns(item.schema.properties, item.name)
        }
    });
    return arr
};

const generatePredefinedFilter = (predefinedFilter = [], columns) => {
    let result = [];
    if(!predefinedFilter.length) return result;

    for(let filter of predefinedFilter) {
        result.push({field: findColumnByName(columns, filter.field)})
    }

    return result;
};

function findForDroppedColumn(source, columns, parentName) {
    for (let col of source) {
        const currentName = parentName ? `${parentName}.${col.name}` : col.name;
        const isPresent = col.dropped = Boolean(columns.find(c => c.name === currentName));
        if (col.properties) {
            col.dropped = isPresent;
            findForDroppedColumn(col.properties, columns, currentName)
        } else {
            col.dropped = isPresent;
        }
        // if (col.properties) {
        //     findForDroppedColumn(col.properties, columns, currentName)
        // } else {
        //     col.dropped = Boolean(columns.find(c => c.name === currentName))
        // }
    }
}

function findColumnByName(source, name, parentName, parentEntity) {
    for (let item of source) {
        let currentItem = parentEntity ? {entity: parentEntity, ...item} : item;
        const result = matchColumn(currentItem, name, parentName);
        if (result) {
            return result
        }
    }
}

function matchColumn(column, name, parentName) {
    const currentMatchName = parentName ? `${parentName}.${column.name}` : column.name;
    if (currentMatchName === name) {
        return {...column, name: currentMatchName};
    } else if (column.properties) {
        return findColumnByName(column.properties, name, currentMatchName, column.entity)
    }
}

export {
    reorder,
    copy,
    copySort,
    copyValues,
    checkForDroppedColumns,
    orderedColumns,
    copyFromColumns,
    generatePredefinedFilter
}